import { availabilityGridQueryKeys as e } from "./useCalendarQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { propertiesApi as n } from "@maat/api-main";
//#region src/calendar/usePropertyAvailabilityGridQuery.ts
var r = (r, i, a) => t({
	queryKey: e.forProperty(r, i, a),
	queryFn: () => n.getAvailabilityGrid(r, {
		from: i,
		to: a
	}),
	enabled: !!r && !!i && !!a,
	staleTime: 3e4
});
//#endregion
export { r as usePropertyAvailabilityGridQuery };
